/* eslint-disable */
import React from 'react'
import Accordion from '../../components/accordion'
import Sidebar from './sidebar-faq'
import { Col } from 'react-flexbox-grid'
import styled from 'styled-components'
import Helmet from 'react-helmet'

import { useTranslation } from 'react-i18next'

const HelpPageStyle = styled.div`
  @media screen and (min-width: 300px) and (max-width: 700px) {
    .sidebar-help-custom-navigation {
      width: 100% !important;
      margin-bottom: 20px;
    }

    .sidebar-help-custom-content {
      width: 100% !important;
      padding-left: 0 !important;
    }
  }
`

const Faq = () => {
  const { t } = useTranslation()
  const data = [
    {
      title: t('pageFaq.part1'),
      number: 1,
      targetScroll: 'faq-1',
      child: {
        title: t('pageFaq.part2'),
        data: [
          {
            title: t('pageFaq.part3'),
            content: [
              {
                text: t('pageFaq.part4')
              }
            ]
          },
          {
            title: t('pageFaq.part5'),
            content: [
              {
                text: t('pageFaq.part6')
              }
            ]
          },
          {
            title: t('pageFaq.part7'),
            content: [
              {
                text: t('pageFaq.part8')
              }
            ]
          },
          {
            title: t('pageFaq.part9'),
            content: [
              {
                text: t('pageFaq.part10')
              }
            ]
          },
          {
            title: t('pageFaq.part11'),
            content: [
              {
                text: t('pageFaq.part12')
              }
            ]
          },
          {
            title: t('pageFaq.part13'),
            content: [
              {
                text: t('pageFaq.part14')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pageFaq.part15'),
      number: 2,
      targetScroll: 'faq-2',
      child: {
        title: t('pageFaq.part16'),
        data: [
          {
            title: t('pageFaq.part17'),
            content: [
              {
                text: t('pageFaq.part18')
              }
            ]
          },
          {
            title: t('pageFaq.part19'),
            content: [
              {
                text: t('pageFaq.part20')
              }
            ]
          },
          {
            title: t('pageFaq.part21'),
            content: [
              {
                text: t('pageFaq.part22')
              }
            ]
          },
          {
            title: t('pageFaq.part23'),
            content: [
              {
                text: t('pageFaq.part24')
              }
            ]
          },
          {
            title: t('pageFaq.part25'),
            content: [
              {
                text: t('pageFaq.part26')
              }
            ]
          },
          {
            title: t('pageFaq.part27'),
            content: [
              {
                text: t('pageFaq.part28')
              }
            ]
          },
          {
            title: t('pageFaq.part29'),
            content: [
              {
                text: t('pageFaq.part30')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pageFaq.part31'),
      number: 3,
      targetScroll: 'faq-3',
      child: {
        title: t('pageFaq.part32'),
        data: [
          {
            title: t('pageFaq.part33'),
            content: [
              {
                text: t('pageFaq.part34')
              }
            ]
          },
          {
            title: t('pageFaq.part35'),
            content: [
              {
                text: t('pageFaq.part36')
              }
            ]
          },
          {
            title: t('pageFaq.part37'),
            content: [
              {
                text: t('pageFaq.part38')
              }
            ]
          },
          {
            title: t('pageFaq.part39'),
            content: [
              {
                text: t('pageFaq.part40')
              }
            ]
          },
          {
            title: t('pageFaq.part41'),
            content: [
              {
                text: t('pageFaq.part42')
              }
            ]
          },
          {
            title: t('pageFaq.part43'),
            content: [
              {
                text: t('pageFaq.part44')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pageFaq.part45'),
      number: 4,
      targetScroll: 'faq-4',
      child: {
        title: t('pageFaq.part46'),
        data: [
          {
            title: t('pageFaq.part47'),
            content: [
              {
                text: t('pageFaq.part48')
              }
            ]
          },
          {
            title: t('pageFaq.part49'),
            content: [
              {
                text: t('pageFaq.part50')
              }
            ]
          },
          {
            title: t('pageFaq.part51'),
            content: [
              {
                text: t('pageFaq.part52')
              }
            ]
          },
          {
            title: t('pageFaq.part53'),
            content: [
              {
                text: t('pageFaq.part54')
              }
            ]
          },
          {
            title: t('pageFaq.part55'),
            content: [
              {
                text: t('pageFaq.part56')
              }
            ]
          },
          {
            title: t('pageFaq.part57'),
            content: [
              {
                text: t('pageFaq.part58')
              }
            ]
          },
          {
            title: t('pageFaq.part59'),
            content: [
              {
                text: t('pageFaq.part60')
              }
            ]
          },
          {
            title: t('pageFaq.part61'),
            content: [
              {
                text: t('pageFaq.part62')
              }
            ]
          }
        ]
      }
    },
    {
      title: t('pageFaq.part63'),
      number: 5,
      targetScroll: 'faq-5',
      child: {
        title: t('pageFaq.part64'),
        data: [
          {
            title: t('pageFaq.part65'),
            content: [
              {
                text: t('pageFaq.part66')
              }
            ]
          },
          {
            title: t('pageFaq.part67'),
            content: [
              {
                text: t('pageFaq.part68')
              }
            ]
          },
          {
            title: t('pageFaq.part69'),
            content: [
              {
                text: t('pageFaq.part70')
              }
            ]
          },
          {
            title: t('pageFaq.part71'),
            content: [
              {
                text: t('pageFaq.part72')
              }
            ]
          },
          {
            title: t('pageFaq.part73'),
            content: [
              {
                text: t('pageFaq.part74')
              }
            ]
          },
          {
            title: t('pageFaq.part75'),
            content: [
              {
                text: t('pageFaq.part76')
              }
            ]
          },
          {
            title: t('pageFaq.part77'),
            content: [
              {
                text: t('pageFaq.part78')
              }
            ]
          },
          {
            title: t('pageFaq.part79'),
            content: [
              {
                text: t('pageFaq.part80')
              }
            ]
          }
        ]
      }
    }
  ]
  return (
    <div style={{ width: '100%' }}>
      <HelpPageStyle>
        <Helmet>
          <title>Pertanyaan Frekuensi Terbanyak | halojasa.com</title>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="Temukan seluruh jawaban dari pertanyaan yang sering Anda tanyakan seputar halo jasa"
          />
          <meta
            property="og:title"
            content="Pertanyaan Frekuensi Terbanyak | halojasa.com"
          />
          <meta property="og:site_name" content="Halo Jasa" />
          <meta
            property="og:description"
            content="Temukan seluruh jawaban dari pertanyaan yang sering Anda tanyakan seputar halo jasa"
          />
          <meta property="og:url" content="https://halojasa.com/bantuan/faq/" />
          <meta
            property="og:image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta
            property="og:image:secure_url"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
          <meta
            property="og:image"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta
            property="og:image:secure_url"
            itemProp="image"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-sq.png"
          />
          <meta property="og:image:type" content="image/png" />
          <meta property="og:image:width" content="300" />
          <meta property="og:image:height" content="300" />
          <meta property="og:type" content="website" />
          <meta property="fb:app_id" content="951866408583742" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@pthalojasa" />
          <meta
            name="twitter:title"
            content="Pertanyaan Frekuensi Terbanyak | halojasa.com"
          />
          <meta
            name="twitter:description"
            content="Temukan seluruh jawaban dari pertanyaan yang sering Anda tanyakan seputar halo jasa"
          />
          <meta
            name="twitter:image:src"
            content="https://halojasa.com/blog/wp-content/uploads/2020/06/home-ls.png"
          />
          <meta name="keyword" content="faq" />
          <link rel="canonical" href="https://halojasa.com/bantuan/faq/" />
        </Helmet>
        <Col
          style={{
            width: '350px',
            display: 'inline-block',
            verticalAlign: 'top'
          }}
          className="sidebar-help-custom-navigation"
        >
          <Sidebar />
        </Col>

        <Col
          style={{
            width: 'calc(100% - 350px)',
            display: 'inline-block',
            verticalAlign: 'top',
            boxSizing: 'border-box',
            paddingLeft: '20px'
          }}
          className="sidebar-help-custom-content"
        >
          {data.map(item => {
            return (
              <Accordion key={item.number} {...item} withNumber></Accordion>
            )
          })}
        </Col>
      </HelpPageStyle>
    </div>
  )
}

export default Faq
